import { useEffect, useState } from "react";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { PeopleIcon } from "src/Pages/components/Icons/Icons";
import { api } from "src/shared/setup/API/api";

interface ICountStatics {
  data: {
    countPropostas: string;
    countParcelasRecebidas: string;
    countParcelasPagas: string;
    countAdministradoras: string;
    countModalidades: string;
    countOperadoras: string;
  };
}

export const UseGetCountStatics = () => {
  const { handleGetAlert } = useLayoutMainContext();

  const [loading, setLoading] = useState(false);

  const [values, setValues] = useState<ICountStatics>();

  useEffect(() => {
    setLoading(true);

    api
      .post("/dashboard/corretora/count")
      .then((res) => setValues(res.data))
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  }, []);

  const dataCountStatics = [
    {
      value1: {
        value: values?.data.countOperadoras || "0",
      },
      name: "Total operadoras",
      icon: <PeopleIcon />
    },
    {
      value1: {
        value: values?.data.countModalidades || "0",
      },
      name: "Total modalidades",
      icon: <PeopleIcon />
    },
    {
      value1: {
        value: values?.data.countAdministradoras || "0",
      },
      name: "Total administradora",
      icon: <PeopleIcon />
    },
    {
      value1: {
        value: values?.data.countPropostas || "0",
      },
      name: "Proposta criadas",
      icon: <PeopleIcon />
    },
    {
      value1: {
        value: values?.data.countParcelasRecebidas || "0",
      },
      name: "Parcelas recebidas",
      icon: <PeopleIcon />
    },
    {
      value1: {
        value: values?.data.countParcelasPagas || "0",
      },
      name: "Parcelas pagas (corretor)",
      icon: <PeopleIcon />
    },
  ];

  return { dataCountStatics, loading };
};
